import styled, { css } from 'styled-components';

export const BREAKPOINT_MOBILE = 'mobile';

export const GroupWrapper = styled.div<{ $isAuthenticated: boolean }>`
    padding: 20px 20px 0 20px;
    width: 100%;

    max-width: 1920px;
    margin: 0 auto;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        padding: 0 40px;
    }
`;

export const FiltersWrapper = styled.div<{ $error?: boolean }>`
    ${({ $error }) =>
        $error &&
        css`
            opacity: 0.3;
            pointer-events: none;
        `}
`;

export const Header = styled.header`
    && {
        display: grid;
        grid-template-columns: 1fr;
        margin-bottom: 30px;

        @media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINT_MOBILE]}) {
            gap: 50px;
            margin-bottom: 60px;
            padding-top: 30px;
        }

        @media (min-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
            grid-template-columns: 1fr 240px;
        }
    }
`;

export const Container = styled.section`
    && {
        display: grid;
        grid-template-columns: 1fr;

        @media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINT_MOBILE]}) {
            grid-template-columns: 1fr 240px;
            gap: 50px;
        }
    }
`;

export const GroupSortingContainer = styled(Container)`
    && {
        margin: 0 0 22px 0;
        padding-bottom: 22px;

        @media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINT_MOBILE]}) {
            margin: 0 0 10px 0;
            padding-bottom: 10px;
        }
    }
`;

export const GroupFiltersWrapper = styled.div`
    && {
        box-sizing: border-box;
        overflow: hidden auto;

        /* scrollbar styling */
        scrollbar-width: thin;
        scrollbar-color: ${({ theme }) => theme.shades.white[10]} transparent;
        ::-webkit-scrollbar {
            width: 0.1875rem;
        }
        ::-webkit-scrollbar-track {
            background: transparent;
        }
        ::-webkit-scrollbar-thumb {
            background: ${({ theme }) => theme.shades.white[10]};
        }
    }
`;

export const GroupFilterSticky = styled.div<{ $height: number }>`
    && {
        display: none;
        position: sticky;
        top: 95px;

        @media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINT_MOBILE]}) {
            display: block;
        }
    }
`;
